function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ItemMemberLevel, useTopicMembersPage_RemoveMemberFromTopicMutation, useTopicMembersPage_SetTopicMemberAdminMutation, useTopicMembersPage_AcceptRequestToJoinTopicMutation, useTopicMembersPage_AcceptTopicInviteMutation, useTopicMembersPage_TopicTransferOwnershipMutation } from "sprout-graphql";
import { Menu, useMenuState, MenuTrigger, MenuItem } from "@sprout/list-navigation/dist/Menu";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import ActionConfirmationDialog from "@sprout/client-components/dist/Dialog/ActionConfirmationDialog";
import useToggle from "@sprout/hooks/dist/useToggle";
import { allowedNumberOfPrivateTopics } from "sprout-lib";
import { convertTopicMemberToItemMemberLevel } from "@sprout/client-lib";
const TopicMembersPageTopicMemberMenu = (props)=>{
    var ref;
    const { currentUserMemberLevel , topicMember , topicId , isTopicPublic , isPartOfPaidTeam ,  } = props;
    const { admin  } = topicMember;
    const topicMemberMemberLevel = convertTopicMemberToItemMemberLevel(topicMember);
    const currentUser = useCurrentUser();
    const topicMemberUserId = Number((ref = topicMember.user) === null || ref === void 0 ? void 0 : ref.id);
    const isCurrentUser = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) === topicMemberUserId;
    const showSnackbar = useSnackbar();
    //
    const [transferring, openTransferring, closeTransferring] = useToggle();
    const [topicTransferOwnershipMutation] = useTopicMembersPage_TopicTransferOwnershipMutation({
        refetchQueries: [
            "TopicMembersPage"
        ],
        variables: {
            topicId,
            userId: topicMemberUserId
        }
    });
    const topicTransferOwnership = function() {
        var _ref = _asyncToGenerator(function*() {
            if (!transferring) {
                openTransferring();
                return;
            }
            closeTransferring();
            try {
                yield topicTransferOwnershipMutation();
                showSnackbar({
                    message: "Tree ownership transferred"
                });
            } catch (e) {
                showSnackbar.error();
            }
        });
        return function topicTransferOwnership() {
            return _ref.apply(this, arguments);
        };
    }();
    //
    const [removing, openRemoving, closeRemoving] = useToggle();
    const [removeTopicMemberMutation] = useTopicMembersPage_RemoveMemberFromTopicMutation({
        refetchQueries: [
            "TopicMembersPage"
        ],
        variables: {
            topicId,
            userId: topicMemberUserId
        }
    });
    const removeTopicMemberWithoutWarning = ()=>{
        removeTopicMemberMutation();
    };
    const removeTopicMember = ()=>{
        if (!removing) {
            openRemoving();
            return;
        }
        closeRemoving();
        removeTopicMemberMutation();
    };
    //
    const nextAdmin = !admin;
    const [setAdminMutation] = useTopicMembersPage_SetTopicMemberAdminMutation({
        variables: {
            topicId,
            userId: topicMemberUserId,
            admin: nextAdmin
        }
    });
    const setAdmin = function() {
        var _ref = _asyncToGenerator(function*() {
            try {
                yield setAdminMutation();
                showSnackbar({
                    message: `${nextAdmin ? "Promoted" : "Demoted"} to tree ${nextAdmin ? "editor" : "member"}`
                });
            } catch (e) {
                showSnackbar.error();
            }
        });
        return function setAdmin() {
            return _ref.apply(this, arguments);
        };
    }();
    //
    const [leaving, openLeaving, closeLeaving] = useToggle();
    const leaveTopic = function() {
        var _ref = _asyncToGenerator(function*() {
            if (!leaving) {
                openLeaving();
                return;
            }
            closeLeaving();
            try {
                yield removeTopicMemberMutation();
                showSnackbar({
                    message: "You have left the tree"
                });
            } catch (e) {
                showSnackbar.error();
            }
        });
        return function leaveTopic() {
            return _ref.apply(this, arguments);
        };
    }();
    //
    const [acceptRequestToJoinTopicMutation] = useTopicMembersPage_AcceptRequestToJoinTopicMutation({
        variables: {
            topicId,
            userId: topicMemberUserId
        }
    });
    const acceptRequestToJoinTopic = ()=>{
        acceptRequestToJoinTopicMutation();
    };
    //
    const [acceptTopicInviteMutation] = useTopicMembersPage_AcceptTopicInviteMutation({
        variables: {
            topicId
        }
    });
    const acceptTopicInvite = function() {
        var _ref = _asyncToGenerator(function*() {
            try {
                yield acceptTopicInviteMutation();
                showSnackbar({
                    message: "You have joined the tree"
                });
            } catch (e) {
                showSnackbar.error();
            }
        });
        return function acceptTopicInvite() {
            return _ref.apply(this, arguments);
        };
    }();
    let menuItems;
    switch(currentUserMemberLevel){
        case ItemMemberLevel.Owner:
            switch(topicMemberMemberLevel){
                case ItemMemberLevel.Admin:
                    var ref1, ref2;
                    menuItems = /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(MenuItem, {
                                disabled: !(isTopicPublic || ((ref1 = topicMember.user) === null || ref1 === void 0 ? void 0 : ref1.plan) || // Number(undefined) < 5 = false
                                Number((ref2 = topicMember.user) === null || ref2 === void 0 ? void 0 : ref2.privateTopics.totalCount) < allowedNumberOfPrivateTopics || isPartOfPaidTeam),
                                onClick: topicTransferOwnership,
                                label: "Promote to tree owner"
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                onClick: setAdmin,
                                label: "Demote to tree member"
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                onClick: removeTopicMember,
                                label: "Remove from tree"
                            })
                        ]
                    });
                    break;
                case ItemMemberLevel.Contributor:
                    menuItems = /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(MenuItem, {
                                onClick: setAdmin,
                                label: "Promote to tree editor"
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                onClick: removeTopicMember,
                                label: "Remove from tree"
                            })
                        ]
                    });
                    break;
                case ItemMemberLevel.Pending:
                    menuItems = /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(MenuItem, {
                                onClick: acceptRequestToJoinTopic,
                                label: " Accept request "
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                onClick: removeTopicMemberWithoutWarning,
                                label: " Decline request "
                            })
                        ]
                    });
                    break;
                default:
                    if (!isCurrentUser) menuItems = /*#__PURE__*/ _jsx(MenuItem, {
                        onClick: removeTopicMember,
                        label: "Remove from tree"
                    });
                    break;
            }
            break;
        case ItemMemberLevel.Admin:
            switch(topicMemberMemberLevel){
                case ItemMemberLevel.Contributor:
                case ItemMemberLevel.Invited:
                    menuItems = /*#__PURE__*/ _jsx(MenuItem, {
                        onClick: removeTopicMember,
                        label: "Remove from tree"
                    });
                    break;
                default:
                    if (isCurrentUser) menuItems = /*#__PURE__*/ _jsx(MenuItem, {
                        onClick: leaveTopic,
                        label: "Leave tree"
                    });
                    break;
            }
            break;
        case ItemMemberLevel.Contributor:
            if (isCurrentUser) menuItems = /*#__PURE__*/ _jsx(MenuItem, {
                onClick: leaveTopic,
                label: "Leave tree"
            });
            break;
        case ItemMemberLevel.Invited:
            if (isCurrentUser) menuItems = /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(MenuItem, {
                        onClick: acceptTopicInvite,
                        label: "Accept"
                    }),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        onClick: removeTopicMemberWithoutWarning,
                        label: "Decline"
                    })
                ]
            });
            break;
        default:
            break;
    }
    const menuState = useMenuState();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            menuItems && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(MenuTrigger, _objectSpread({}, menuState)),
                    /*#__PURE__*/ _jsx(Menu, _objectSpread({}, menuState, {
                        children: menuItems
                    }))
                ]
            }),
            /*#__PURE__*/ _jsx(ActionConfirmationDialog, {
                title: "Transfer tree ownership",
                content: "Are you sure you want to transfer ownership of this tree? <br /> <br /> The new tree owner will have ultimate authority over this tree. You will be demoted to tree admin.",
                actionText: "Transfer",
                onActionClick: topicTransferOwnership,
                open: transferring,
                onRequestClose: closeTransferring
            }),
            /*#__PURE__*/ _jsx(ActionConfirmationDialog, {
                title: "Remove tree member",
                content: "Tree member will lose access to the tree, but their content will remain unless the member chooses to delete it.",
                actionText: "Remove",
                onActionClick: removeTopicMember,
                open: removing,
                onRequestClose: closeRemoving
            }),
            /*#__PURE__*/ _jsx(ActionConfirmationDialog, {
                title: "Leave tree",
                content: "When you leave a tree, your content will remain unless you delete it before leaving.",
                actionText: "Leave",
                onActionClick: leaveTopic,
                open: leaving,
                onRequestClose: closeLeaving
            })
        ]
    });
};
export default TopicMembersPageTopicMemberMenu;
